import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withKeys as _withKeys, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-c3e06f50"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top_boxs"
};
const _hoisted_2 = {
  class: "topic_box"
};
const _hoisted_3 = {
  class: "topic-list"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "el-icon-select"
};
const _hoisted_6 = {
  class: "dialog-footer"
};
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { Search } from "@element-plus/icons-vue";
import { getCaseTopicListApi } from "@/service/modules/case";
export default /*#__PURE__*/_defineComponent({
  __name: 'topic-dialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    itemData: {
      type: Array,
      default: () => []
    }
  },
  emits: ["closeDialog", "restData"],
  setup(__props, {
    emit: __emit
  }) {
    const route = useRoute();
    const router = useRouter();
    const props = __props;
    const emit = __emit;
    const search = ref("");
    const originalArray = ref([]);
    const searchTopic = () => {
      const filteredArr = originalArray.value.filter(item => item.name.includes(search.value));
      list_data.value = JSON.parse(JSON.stringify(filteredArr));
    };
    const clearChange = () => {
      list_data.value = JSON.parse(JSON.stringify(originalArray.value));
    };
    function handleFooterBtn(actionType) {
      if (!actionType) {
        closeDialog();
        return;
      }
      emit("restData", list_data_select());
      //   console.log(list_data_select(), "提交", list_data.value);
    }

    const list_data = ref([]);
    async function getListApi() {
      let reqdata = {
        page: 1,
        pageSize: 300
      };
      const res = await getCaseTopicListApi(reqdata);
      let data_list = res.data.data.map(item => {
        return {
          name: item.name,
          id: item.id,
          is_select: false
        };
      });
      //判断itemData是否有东西，有东西就把里面is_select=true的赋值到data_list
      if (props.itemData.length > 0) {
        props.itemData.forEach(item => {
          data_list.forEach(item2 => {
            if (item2.id === item.id) {
              item2.is_select = true;
            }
          });
        });
      }
      list_data.value = data_list;
      originalArray.value = JSON.parse(JSON.stringify(data_list));
    }
    getListApi();
    const selectTopic = (item, index) => {
      list_data.value[index].is_select = !list_data.value[index].is_select;
    };
    function closeDialog() {
      emit("closeDialog");
    }
    //过滤出list_data里面is_select=true 的
    const list_data_select = () => {
      let res_list = list_data.value.filter(item => {
        return item.is_select;
      });
      return res_list;
    };
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_dialog, {
        "model-value": __props.dialogVisible,
        title: "话题管理",
        width: "35%",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "before-close": closeDialog,
        class: "topic_dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_6, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => handleFooterBtn(false))
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = $event => handleFooterBtn(true)),
          type: "primary"
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_input, {
          modelValue: search.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => search.value = $event),
          style: {
            "height": "34px"
          },
          placeholder: "搜索话题",
          clearable: "",
          onClear: clearChange,
          onKeyup: _withKeys(searchTopic, ["enter"])
        }, {
          prefix: _withCtx(() => [_createVNode(_component_el_icon, {
            class: "el-input__icon"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Search))]),
            _: 1
          })]),
          _: 1
        }, 8, ["modelValue", "onKeyup"]), _createVNode(_component_el_button, {
          type: "primary",
          style: {
            "margin-left": "10px"
          },
          onClick: searchTopic
        }, {
          default: _withCtx(() => [_createTextVNode("搜索")]),
          _: 1
        })])]), _createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list_data.value, (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["item-top", item.is_select ? 'select' : 'noselect']),
            key: index,
            onClick: $event => selectTopic(item, index)
          }, [_createElementVNode("span", null, _toDisplayString(item.name), 1), _withDirectives(_createElementVNode("i", _hoisted_5, null, 512), [[_vShow, item.is_select]])], 10, _hoisted_4);
        }), 128))])]),
        _: 1
      }, 8, ["model-value"])]);
    };
  }
});